import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

export const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  margin-bottom: 1.25rem;
  padding-bottom: 0.25rem;

  ::-webkit-scrollbar {
    display: none;
  }
`;

type FilterChipProps = TransientProps<{ active: boolean }>;

export const FilterChip = styled.button<FilterChipProps>`
  ${({ theme, $active: isActive }) => css`
    padding: 0.5rem 1.125rem;
    border-radius: 9999px;
    border: 1.5px solid
      ${isActive
        ? theme.colors.brand.primary.default
        : theme.colors.base.border};
    background: ${isActive
      ? theme.colors.brand.primary.default
      : theme.colors.background[100]};
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${isActive
      ? theme.colors.brand.primary.text
      : theme.colors.foreground[40]};
    cursor: pointer;
    transition: ${theme.transition.default};
    white-space: nowrap;

    :hover {
      border-color: ${theme.colors.brand.primary.default};
      color: ${isActive
        ? theme.colors.brand.primary.text
        : theme.colors.brand.primary.default};
    }
  `}
`;
